/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import {BarChart, LineChart, PieChart} from '../../../components/Charts';
export const euGeneralData = {
  population: '447.0 million (1 January 2022)',
  laborForce: '195.7 million (Q3 2021)',
  unemploymentRate: '6.2% (April 2022)',
  gdpPerCapita: '€27,830 (2021)'
};
export const euGdpContributionData = [{
  name: 'Germany',
  value: 25.1
}, {
  name: 'France',
  value: 17.3
}, {
  name: 'Italy',
  value: 12.4
}, {
  name: 'Spain',
  value: 8.4
}, {
  name: 'Netherlands',
  value: 6.0
}, {
  name: 'Other EU Countries',
  value: 30.8
}];
export const purchasingPowerData = [{
  name: 'Germany',
  value: 23779,
  percentage: 61
}, {
  name: 'Netherlands',
  value: 20416,
  percentage: 39
}, {
  name: 'France',
  value: 20306,
  percentage: 38
}, {
  name: 'Italy',
  value: 17779,
  percentage: 21
}, {
  name: 'Spain',
  value: 14636,
  percentage: -0.7
}, {
  name: 'Czech Republic',
  value: 9959,
  percentage: -32
}, {
  name: 'Poland',
  value: 7589,
  percentage: -48
}, {
  name: 'Hungary',
  value: 7416,
  percentage: -50
}, {
  name: 'Romania',
  value: 5881,
  percentage: -60
}];
export const clothingSpendingByCountryData = [{
  name: 'United Kingdom',
  value: 65.4
}, {
  name: 'Germany',
  value: 62.7
}, {
  name: 'Italy',
  value: 52.4
}, {
  name: 'France',
  value: 35.7
}, {
  name: 'Spain',
  value: 24.1
}, {
  name: 'Netherlands',
  value: 14.6
}];
export const averageSpendingPerCapitaData = [{
  name: 'Luxembourg',
  value: 1130
}, {
  name: 'Austria',
  value: 810
}, {
  name: 'Netherlands',
  value: 770
}, {
  name: 'Denmark',
  value: 750
}, {
  name: 'Italy',
  value: 710
}, {
  name: 'Germany',
  value: 640
}, {
  name: 'Belgium',
  value: 630
}, {
  name: 'Ireland',
  value: 620
}, {
  name: 'Cyprus',
  value: 620
}, {
  name: 'Finland',
  value: 610
}];
export const employmentData = [{
  sector: 'Textiles',
  employees: 537482,
  companies: 48343
}, {
  sector: 'Clothing',
  employees: 760637,
  companies: 94591
}];
export const companySizeData = [{
  name: 'Micro (0-9 employees)',
  value: 88.8
}, {
  name: 'Small/Medium (10-249)',
  value: 11.0
}, {
  name: 'Large (250+)',
  value: 0.2
}];
export const tradeTextileData = [{
  year: '2020',
  exports: 53,
  imports: 115,
  balance: -62
}, {
  year: '2021',
  exports: 58,
  imports: 106,
  balance: -48
}];
export const clothingImportSourcesData = [{
  name: 'China',
  value: 21,
  percentage: 30
}, {
  name: 'Bangladesh',
  value: 12,
  percentage: 18
}, {
  name: 'Turkey',
  value: 8,
  percentage: 12
}, {
  name: 'United Kingdom',
  value: 4,
  percentage: 6
}, {
  name: 'India',
  value: 3,
  percentage: 4
}, {
  name: 'Vietnam',
  value: 3,
  percentage: 4
}, {
  name: 'Cambodia',
  value: 2,
  percentage: 3
}];
export const sustainabilityData = [{
  name: 'Price',
  value: 68
}, {
  name: 'Quality',
  value: 61
}, {
  name: 'Fit',
  value: 56
}, {
  name: 'Product Life',
  value: 30
}, {
  name: 'Fabric',
  value: 24
}, {
  name: 'Production Location',
  value: 16
}, {
  name: 'Brand',
  value: 16
}, {
  name: 'Environmental Impact',
  value: 15
}];
function _createMdxContent(props) {
  const _components = Object.assign({
    h2: "h2",
    table: "table",
    thead: "thead",
    tr: "tr",
    th: "th",
    tbody: "tbody",
    td: "td",
    strong: "strong",
    h3: "h3",
    p: "p",
    a: "a",
    em: "em",
    h4: "h4"
  }, _provideComponents(), props.components), {ChartGrid} = _components;
  if (!ChartGrid) _missingMdxReference("ChartGrid", true);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h2, {
      children: "General data"
    }), "\n", _jsxs(_components.table, {
      children: [_jsx(_components.thead, {
        children: _jsxs(_components.tr, {
          children: [_jsx(_components.th, {
            children: "Metric"
          }), _jsx(_components.th, {
            children: "Value"
          })]
        })
      }), _jsxs(_components.tbody, {
        children: [_jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.strong, {
              children: "Population:"
            })
          }), _jsx(_components.td, {
            children: "447.0 million (1 January 2022) Source: Eurostat, July 2022"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.strong, {
              children: "Labor Force:"
            })
          }), _jsx(_components.td, {
            children: "195.7 million (in the third quarter of 2021) Source: Statista, January 2022"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.strong, {
              children: "Unemployment Rate:"
            })
          }), _jsx(_components.td, {
            children: "6.2% (April 2022) Source: Statista, July 2022"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.strong, {
              children: "Gross domestic product (GDP) Per Capita:"
            })
          }), _jsx(_components.td, {
            children: "€27,830 (in 2021) Source: Eurostat, July 2022"
          })]
        })]
      })]
    }), "\n", _jsx(_components.h3, {
      children: "The European Union"
    }), "\n", _jsx(_components.p, {
      children: "The European Union consists of 27 countries (Member States): Austria, Belgium, Bulgaria, Cyprus, Czech Republic, Denmark, Estonia, Finland, France, Germany, Greece, Hungary, Ireland, Italy, Croatia, Latvia, Lithuania, Luxembourg, Malta, Netherlands, Poland, Portugal, Romania, Slovakia, Slovenia, Spain and Sweden. (On 31 January 2020, the United Kingdom left the EU)."
    }), "\n", _jsx(_components.h3, {
      children: "GDP European Union 2020"
    }), "\n", _jsxs(_components.p, {
      children: ["The largest economies in the European Union are ", _jsx(_components.a, {
        href: "https://fashionunited.de/statistics/zahlen-und-fakten-zur-deutschen-modeindustrie",
        children: "Germany"
      }), " (25.1% contribution to the European Union's gross domestic product in 2020), ", _jsx(_components.a, {
        href: "https://fashionunited.fr/statistics/industrie-de-la-mode-habillement-statistiques-france",
        children: "France"
      }), " (17.3%), ", _jsx(_components.a, {
        href: "https://fashionunited.it/statistics/statistiche-moda-italia",
        children: "Italy"
      }), " (12.4%), ", _jsx(_components.a, {
        href: "https://fashionunited.es/statistics/estadisticas-de-consumo-y-ventas-de-la-moda-en-espana",
        children: "Spain"
      }), " (8.4%) and ", _jsx(_components.a, {
        href: "https://fashionunited.nl/statistics/statistieken-modebranche-nederland",
        children: "the Netherlands"
      }), " (6%). Together, these economies have a total of almost 70%.\n", _jsx("small", {
        children: "States CBS in July 2021, based on Eurostat data"
      })]
    }), "\n", _jsx(PieChart, {
      data: euGdpContributionData,
      dataKey: "value",
      nameKey: "name",
      title: "EU GDP Contribution by Country (2020)",
      subtitle: "Percentage contribution to EU GDP",
      source: "CBS, July 2021, based on Eurostat data",
      valueSuffix: "%",
      valueLabel: "GDP Contribution",
      colors: ['#8884d8', '#82ca9d', '#ffc658', '#ff7300', '#00C49F', '#FFBB28']
    }), "\n", _jsx(_components.h3, {
      children: "European Purchasing Power"
    }), "\n", _jsx(_components.p, {
      children: "In 2019, Europeans had an average of €14,739 per person available for spending and saving. Purchasing power per capita increased by about 3.5% in 2019 (year on year). Liechtenstein, Switzerland and Luxembourg have the highest average purchasing power, Moldova, Kosovo and Ukraine the lowest. 16 of the 42 countries surveyed in the study have above average purchasing power per capita, while 26 countries are below the European average."
    }), "\n", _jsx("div", {
      className: "chart-grid",
      children: _jsx(BarChart, {
        data: purchasingPowerData,
        dataKey: "value",
        xAxisKey: "name",
        title: "Purchasing Power per Capita in EU Countries (2019)",
        subtitle: "Euros per capita",
        source: "GfK Purchasing Power Europe 2019 study, October 2019",
        valuePrefix: "€",
        valueLabel: "Purchasing Power",
        color: "#8884d8"
      })
    }), "\n", _jsx("small", {
      children: "Source: 'GfK Purchasing Power Europe 2019' study evaluating 42 countries, October 2019."
    }), "\n", _jsx(_components.h2, {
      children: "Textile consumption in the EU: EU is an important market for fashion"
    }), "\n", _jsx(_components.p, {
      children: "European households consume large amounts of textile products: total consumption in Europe in 2020 was 6.6 million tons of textile products."
    }), "\n", _jsxs(_components.p, {
      children: ["In 2020, Europeans bought an average of 15 kilos of textiles. Of the 15 kilos that are bought on average each year, 6.1 kilos comes from clothing and 2.7 kilos from shoes (the other 6.1 kilos is household textiles).\n", _jsx("small", {
        children: "Source: EU Environment Agency, briefing 'Textiles and the environment: the role of design in Europe's circular economy', February 2022"
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["Every year, 5.8 million tons of textiles are thrown away, about 11.3 kg per person.\n", _jsx("small", {
        children: "Source: European Commission Factsheet Textiles, March 2022"
      })]
    }), "\n", _jsx(_components.p, {
      children: "According to the EU Environment Agency, textiles are in fourth place when it comes to the negative impact on the environment and climate change, if only considering European consumption. Food, housing and transport are number one through three."
    }), "\n", _jsxs(_components.p, {
      children: ["In 2020, textile consumption in Europe had the third largest impact on water and land use, and the fifth in terms of resource use and greenhouse gas emissions.\n", _jsx("small", {
        children: "Source: EU Environment Agency, briefing 'Textiles and the environment: the role of design in Europe's circular economy', February 2022"
      })]
    }), "\n", _jsx(_components.h3, {
      children: "Consumer spending on clothing in the EU: how much do Europeans spend on clothing?"
    }), "\n", _jsx(_components.p, {
      children: "Households in the European Union spent approximately 220 billion euros on clothing in 2020 articles, a decrease of -18% compared to expenditure the year before."
    }), "\n", _jsxs(_components.p, {
      children: ["The average European expenditure on clothing in 2020 was 490 euros. Most money was spent in Luxembourg (1130 euros), Austria (810 euros), the Netherlands (770 euros), Denmark (750 euros), Italy (710 euros), Germany (640 euros), Belgium (630 euros), Ireland (620 euros), Cyprus (620 euros), Finland (610 euros), Sweden (570 euros), and Portugal (500 euros).\n", _jsx("small", {
        children: "From the Facts & Key figures 2022 of the European Textile and Clothing Industry report by Euratex, June 2022. Source: Eurostat"
      })]
    }), "\n", _jsx(BarChart, {
      data: averageSpendingPerCapitaData,
      dataKey: "value",
      xAxisKey: "name",
      title: "Average Clothing Spending per Capita in EU (2020)",
      subtitle: "Euros per person annually",
      source: "Euratex, June 2022. Source: Eurostat",
      valuePrefix: "€",
      valueLabel: "Annual Spending",
      color: "#ff7300"
    }), "\n", _jsxs(_components.p, {
      children: ["In 2020, Europeans spent an average of 4.1% of total household expenditure on clothing and footwear.\n", _jsx("small", {
        children: "Source: Eurostat"
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["In 2019, Europeans still spent an average of 4.6% of their spending on clothing and footwear.\n", _jsx("small", {
        children: "Source: Eurostat, November 2020"
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["On average, Europeans spent around 600 euros on clothing in 2019 (as Europeans also did in 2018), 150 euros on footwear and 70 euros on household textiles.\n", _jsx("small", {
        children: "Source: EU Environment Agency, briefing 'Textiles and the environment: the role of design in Europe's circular economy', February 2022"
      })]
    }), "\n", _jsx(_components.h3, {
      children: "Which European country buys the most clothing?"
    }), "\n", _jsx(_components.p, {
      children: "Household consumption expenditure on clothing in the European Union 2018 was highest in these countries:"
    }), "\n", _jsx(BarChart, {
      data: clothingSpendingByCountryData,
      dataKey: "value",
      xAxisKey: "name",
      title: "Household Clothing Expenditure by EU Country (2018)",
      subtitle: "Billion euros total spending",
      source: "Statista 2022",
      valuePrefix: "€",
      valueSuffix: "B",
      valueLabel: "Total Spending",
      color: "#82ca9d"
    }), "\n", _jsx("small", {
      children: "Source: Household consumption expenditure on clothing in the European Union in 2018, by country, Statista 2022"
    }), "\n", _jsx(_components.h3, {
      children: "Germany is the fourth largest clothing and shoe market in the world"
    }), "\n", _jsxs(_components.p, {
      children: ["Germany is ", _jsx(_components.a, {
        href: "https://fashionunited.com/global-fashion-industry-statistics",
        children: "the fourth largest apparel and footwear market worldwide"
      }), ", following China, the United States and the United Kingdom. The 2021 market size is $69.9 billion dollars."]
    }), "\n", _jsxs(_components.p, {
      children: ["Source: ", _jsx(_components.a, {
        href: "https://fashionunited.com/companies/euromonitor-international",
        children: "Euromonitor International, a market research provider"
      })]
    }), "\n", _jsx(_components.h2, {
      children: "Employment opportunities"
    }), "\n", _jsxs(_components.p, {
      children: ["There are ", _jsx(_components.strong, {
        children: "1.3 million people"
      }), " employed in the textile and clothing industry in Europe at 143,000 companies. 537,482 people work in textiles and 760,637 in clothing.\n", _jsx("small", {
        children: "*2021 estimates. Source: Facts & Key figures 2022 of the European Textile and Clothing Industry report from Euratex, June 2022."
      })]
    }), "\n", _jsxs(ChartGrid, {
      children: [_jsx(BarChart, {
        data: employmentData,
        dataKey: "employees",
        xAxisKey: "sector",
        title: "Employment in EU Textile & Clothing Industry (2021)",
        subtitle: "Number of employees by sector",
        source: "Euratex, June 2022",
        valueLabel: "Employees",
        color: "#8884d8"
      }), _jsx(PieChart, {
        data: companySizeData,
        dataKey: "value",
        nameKey: "name",
        title: "EU Textile & Clothing Company Sizes",
        subtitle: "Distribution by number of employees",
        source: "Euratex, 2020. Eurostat data",
        valueSuffix: "%",
        valueLabel: "Share of Companies",
        colors: ['#FF6B8A', '#5DA5DA', '#FAA43A']
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["Euratex states that the sector is a fundamental pillar of the local economy in many EU regions.\n", _jsx("small", {
        children: "Source: Euratex Spring Report 2022 press release, May 2022"
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["The number of people employed and the number of companies in the sector decreased slightly: -3.2% and -3.3% respectively (percentage change from 2019/2018).\n", _jsx("small", {
        children: "Source: Facts & Key figures 2022 of the European Textile and Clothing Industry from Euratex report, June 2022."
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["In 2019, the number of people employed in the textile and clothing industry in Europe was estimated at 1.5 million in 160,000 companies.\n", _jsx("small", {
        children: "Source: Euratex Key Facts & Figures 2020 report."
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["The majority (+70%) of fashion workers in the EU are women.\n", _jsx("small", {
        children: "Source: Facts & Key figures 2022 of the European Textile and Clothing Industry from Euratex report, June 2022."
      })]
    }), "\n", _jsx(_components.h2, {
      children: "Fashion companies"
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.strong, {
        children: "Textile and clothing industry"
      }), "\nThere are 143,000 companies in the textile and clothing industry in Europe. Of these, 48,343 (33%) companies operate in the textile industry in the broadest sense of the word, and 94,591 (67%) are active in the clothing sector.\n", _jsx("small", {
        children: "*2021 estimates. Source: Facts & Key figures 2022 of the European Textile and Clothing Industry from Euratex report, June 2022."
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["The sector mainly consists of small companies: 99.8% are micro and SME companies. 88.8% of textile & clothing companies are micro companies with up to 9 employees. Small and medium-sized enterprises, with 10-249 employees, account for 11%, and Large enterprises with more than 250 employees account for about 0.2%.\n", _jsx("small", {
        children: "Source: Facts & Key Figures of the European Textile and Clothing Industry report from Euratex, 2020. Euratex calculations, based on Eurostat data."
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["The largest producers in the fashion industry are located in Italy, France, Germany, Spain and Portugal. These countries together account for three quarters of the production in the EU.\n", _jsx("small", {
        children: "States the European Commission on its website, based on CIRCABC database data"
      })]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.strong, {
        children: "The luxury (fashion) sector"
      }), "\nThe luxury fashion sector makes an important contribution to the economy of the EU, according to the European Commission on its website. \"European ", _jsx(_components.em, {
        children: "savoir-faire"
      }), " and craftsmanship have built a worldwide reputation.\" According to the executive body of the European Union, about 5 million people work in the value chain, and more than 1 million in the high-end fashion industry."]
    }), "\n", _jsxs(_components.p, {
      children: ["Most fashion production within the EU takes place in Italy, southern European countries such as Spain, Greece, Portugal, and newer EU countries such as Poland, Romania, Bulgaria, Hungary. The countries with the most companies in distribution and retail are Italy, France, Poland and Germany.\n", _jsx("small", {
        children: "States the European Commission on its website, based on CIRCABC database data"
      })]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.strong, {
        children: "The shoe industry in the European Union"
      }), "\nIn 2018, 19,856 companies were active in the European footwear sector (EU28) and together they employed 260,309 people. In 2012, the total turnover in the shoe industry amounted to 25.24 billion euros.\n", _jsx("small", {
        children: "Source: The European Confederation of the Footwear Industry (CEC)"
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["EU shoe production is concentrated in three countries: Italy, Spain and Portugal. Italy alone accounts for about 50% of production.\n", _jsx("small", {
        children: "Writes the European Commission on its website, based on CIRCABC database data"
      })]
    }), "\n", _jsx(_components.h2, {
      children: "EU: Home to Leading Retailers Worldwide & Europe's Most Valuable Brands Worldwide"
    }), "\n", _jsxs(_components.p, {
      children: ["The largest fashion companies in the world by market value are: Inditex, Nike and LVMH.\n", _jsx("small", {
        children: "Source: FashionUnited Top200"
      })]
    }), "\n", _jsx(_components.p, {
      children: "These are the Top 10 Most Valuable Fashion Brands Worldwide, based on 2020 Brand Value in US dollars:"
    }), "\n", _jsxs(_components.p, {
      children: ["Nike ($36.8 billion), Louis Vuitton ($32.3 billion), Hermes ($18.3 billion), Gucci ($18.2 billion), Zalando ($17.9 billion), Adidas ($16.2 billion), Tiffany & Co ($15.2 billion), Zara ($13.5 billion), H&M ($11.5 billion) and Cartier ($10.7 billion).\nSource: ", _jsx(_components.a, {
        href: "https://fashionunited.com/i/most-valuable-fashion-brands",
        children: "FashionUnited"
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["Looking at these top 10 fashion brands, ", _jsx(_components.strong, {
        children: "Europe is home to the world's largest retailers"
      }), ", such as the Inditex Group, parent company of Zara, Zara Home, Pull & Bear, Massimo Dutti, Bershka, Stradivarius and Oysho in Spain and the H&M Group, owner of H&M, COS, Monki, Weekday, & Other Stories, H&M Home, Arket and Afound, in Sweden. In addition, head offices ", _jsx(_components.strong, {
        children: "of renowned brands and companies"
      }), "such as Louis Vuitton (in Paris), Hermes (Paris), Gucci (Florence), Zalando (Berlin) and Adidas (Herzogenaurach, Germany) are also located in Europe."]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.strong, {
        children: "Louis Vuitton in Top 10 of Europe's Most Valuable Brands"
      }), "\nLouis Vuitton is the only fashion company to be among the top ten most valuable and strongest European brands. Kering brand Gucci is at number 17 in the ranking and Chanel is in 24th place, in the Brand Finance Europe 500 2022 ranking, published in 2022."]
    }), "\n", _jsxs(_components.p, {
      children: ["The retail and apparel sectors account for 11% and 9.1% respectively of the top 500, with a total of 92 companies in the ranking. Hermes ranks 30th, fast fashion giants Zara and H&M 32nd and 35th respectively. L'Oréal is the only cosmetics and personal care company in the top 50 at 42nd place.\nSource: ", _jsx(_components.a, {
        href: "https://fashionunited.uk/news/business/louis-vuitton-in-top-10-of-europe-s-most-valuable%20-brands/2022062263742",
        children: "Brand Finance Europe 500 2022, ranking, published 2022"
      }), "."]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.strong, {
        children: "Europe is also the 'world capital' of textile research, innovation and higher education."
      }), "\n", _jsx("small", {
        children: "From Facts & Key Figures of the European Textile and Clothing Industry report by Euratex, 2020. Source: Eurostat."
      })]
    }), "\n", _jsx(_components.h2, {
      children: "Trade in Clothing: Europe is an important importer and (re-)exporter"
    }), "\n", _jsxs(_components.p, {
      children: ["In 2020, the EU imported 69 billion euros worth of clothing from non-EU member states. EU exports of clothing to countries outside the EU amounted to EUR 30 billion in 2020.\n", _jsx("small", {
        children: "Source: Eurostat 'Where do our clothes come from?', publication 24 April 2021."
      })]
    }), "\n", _jsx(_components.h2, {
      children: "The EU textile and clothing market in a global context"
    }), "\n", _jsxs(_components.p, {
      children: ["The EU plays an important role in the fashion industry worldwide, both as an importer and consumer, but also as a producer and exporter of finished and semi-finished products.\n", _jsx("small", {
        children: "Source: report 'Circular economy perspectives in the EU textile sector' Köhler, A, June 2021."
      })]
    }), "\n", _jsx(_components.p, {
      children: "In 2020, the European Union was the second largest exporter of textiles and clothing worldwide (the leading position going to China). The EU is the largest importer of textiles and clothing worldwide."
    }), "\n", _jsx(LineChart, {
      data: tradeTextileData,
      dataKey: "balance",
      xAxisKey: "year",
      title: "EU Trade Balance in Textiles & Clothing",
      subtitle: "Billion euros (exports minus imports)",
      source: "Euratex 2022",
      valuePrefix: "€",
      valueSuffix: "B",
      valueLabel: "Trade Balance",
      yDomain: [-70, 0],
      color: "#ff7300"
    }), "\n", _jsx(_components.h3, {
      children: "EU Trade Highlights 2021: European textile exports have increased again in 2021"
    }), "\n", _jsx(_components.p, {
      children: "After a dip due to the pandemic in 2020, the export of European textiles and clothing has increased again in 2021. Exports rose by 10.6% in 2021 compared to 2020. Imports of textiles and clothing, however, lagged by 7.5% due to a decrease in suppliers from the United Kingdom and China."
    }), "\n", _jsxs(_components.p, {
      children: ["The change in imports and exports improved the trade deficit (difference between imports and exports). The trade deficit in 2021 amounted to 48 billion euros. A total of 58 billion euros worth of textiles and clothing was exported and 106 billion euros imported in 2021.\n", _jsx("small", {
        children: "Sources: Euratex 2022 Spring Report press release and Facts & Key figures 2022 of the European Textile and Clothing Industry from Euratex report, June 2022."
      })]
    }), "\n", _jsx(_components.h2, {
      children: "EU: Where do our clothes come from?"
    }), "\n", _jsx(_components.h4, {
      children: "Clothing imports to the EU in 2020: 69 billion euros"
    }), "\n", _jsx(_components.p, {
      children: "In 2020, EU member states will have imported 69 billion euros worth of clothing from outside the EU. Most clothing comes from China: 21 billion euros, about 30% of the total. China is followed by Bangladesh (12 billion euros, accounting for about 18%), Turkey (8 billion euros, about 12%), the United Kingdom (4 billion euros, 6%) India and Vietnam (3 billion euros, 4%) and finally, Cambodia (2 billion euros)."
    }), "\n", _jsx(BarChart, {
      data: clothingImportSourcesData,
      dataKey: "value",
      xAxisKey: "name",
      title: "EU Clothing Import Sources (2020)",
      subtitle: "Value in billion euros",
      source: "Eurostat 'Where do our clothes come from?', April 2021",
      valuePrefix: "€",
      valueSuffix: "B",
      valueLabel: "Import Value",
      color: "#00C49F"
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.strong, {
        children: "Germany is the largest importer of clothing in the EU"
      }), "\nGermany imported the most clothing into the EU in 2020, about 17 billion euros and/or 25% of the total import. Germany is followed by Spain (10 billion euros, 15%) and France (almost 10 billion euros, 14%)"]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.strong, {
        children: "Italy is the largest exporter of clothing in the EU"
      }), "\nItaly exported €10 billion worth of clothing to non-EU member states in 2020, 33% of total extra-EU clothing exports by value. After Italy comes Germany (with 5 billion euros, 17%), Spain (with 4 billion euros, 14%) and France (almost 4 billion euros, 13%).\n", _jsx("small", {
        children: "Sources: Eurostat news 'Where do our clothes come from?', April 2021 & Statista Chart Where The EU Imports Its Clothes From 2021, April 2021"
      })]
    }), "\n", _jsx(_components.h2, {
      children: "E-commerce"
    }), "\n", _jsxs(_components.p, {
      children: ["Online shopping is popular in the EU. Total European e-commerce has grown to 718 billion euros in 2021, a 13% increase compared to 2020, when it was still 633 billion euros.\n", _jsx("small", {
        children: "Source: Europe E-Commerce Report 2022"
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["The EU-27 is the driving force behind European B2C e-commerce, according to Ecommerce Europe. \"E-commerce turnover [in the EU] has increased by 16% in 2021. More than 90% of the population is an internet user, and the share of internet users who buy online is expected to reach 76% by 2022.\"\n", _jsx("small", {
        children: "Source: Europe E-Commerce Report 2022"
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["\"E-commerce accounts for about 10 to 15% of total retail sales in the EU,\" said Christian Verschueren, director-general of EuroCommerce, the European voice of retail and wholesale, in a 2021 report from E-commerce Europe, which represents the interests of e-commerce companies. \"Yet it affects a much larger part of the consumer journey (up to 50% or more), which today includes a mix of physical and online.\" ", _jsx("small", {
        children: "Source: European E-commerce Report 2021"
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["According to Verschueren, '70% of retailers, especially micro-enterprises, had no e-commerce offerings before the pandemic.'\n", _jsx("small", {
        children: "Source: European E-commerce Report 2021"
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["There are more than 800,000 online stores in Europe, according to research by Ecommerce News Europe in collaboration with Dataprovider. Nothing is specified for fashion.\n", _jsx("small", {
        children: "Source: Ecommerce News Europe survey with Dataprovider, 2017."
      })]
    }), "\n", _jsx(_components.h4, {
      children: "Zoom in on fashion: we prefer to buy clothes online"
    }), "\n", _jsx(_components.p, {
      children: "The percentage of textile and clothing sales generated by e-sales has more than doubled since 2009: in 2020 it was 11%, in 2009 it was only 5%."
    }), "\n", _jsxs(_components.p, {
      children: ["The most popular category for online purchases is clothing (including sportswear), shoes and/or accessories. That has been the case for years, by the way. 68% of all online shoppers bought clothes, shoes and accessories online in 2020.\n", _jsx("small", {
        children: "Source: Facts & Key figures 2022 of the European Textile and Clothing Industry from Euratex report, June 2022. Data: Eurostat"
      })]
    }), "\n", _jsx(_components.h2, {
      children: "Number of clothing and footwear stores in the EU"
    }), "\n", _jsxs(_components.p, {
      children: ["Number of clothing and footwear (retail) stores in the European Union in 2019: 275,000 in clothing in the EU and 58,000 in footwear and leather goods.\n", _jsx("small", {
        children: "Source: Statista, April 2022"
      })]
    }), "\n", _jsx(_components.h2, {
      children: "Attitude towards sustainability"
    }), "\n", _jsx(_components.h4, {
      children: "In Europe, only 12% of consumers consider sustainability particularly important in the fashion sector"
    }), "\n", _jsx(_components.p, {
      children: "When asked which sectors sustainability ranks most important to consumers, the fashion industry is not very high on the list anywhere in Europe coming only in eighth place with 12%. Consumers consider sustainability more important in the food industry, energy sector, transport, healthcare, travel industry and technology, among others."
    }), "\n", _jsx(_components.h4, {
      children: "Main criteria for buying clothes"
    }), "\n", _jsx(_components.p, {
      children: "Price (68%) is the most important criterion for European consumers when choosing and buying clothes, followed by quality (61%) and fit (56%). After that, the most important criterion is product life (30%), fabric (24%), production location (16%) and brand (16%). The environmental impact of a product is only important for 15% of European consumers, the [current] fashion trends only for 11%."
    }), "\n", _jsx(BarChart, {
      data: sustainabilityData,
      dataKey: "value",
      xAxisKey: "name",
      title: "Main Criteria for Buying Clothes in Europe",
      subtitle: "Percentage of consumers citing as important",
      source: "YouGov's European Fashion Report 2021",
      valueSuffix: "%",
      valueLabel: "Percentage",
      color: "#8884d8"
    }), "\n", _jsx(_components.h4, {
      children: "Where do you buy clothes?"
    }), "\n", _jsx(_components.p, {
      children: "46% of Europeans buy from fast fashion retailers, 17% from thrift stores, 17% from ethical brands, 12% from resale apps and 6% from luxury brands."
    }), "\n", _jsx(_components.h4, {
      children: "How important is sustainable clothing? What do you pay attention to when purchasing and what are the obstacles?"
    }), "\n", _jsxs(_components.p, {
      children: ["In Europe, 42% of consumers consider it important to buy ethical and sustainable clothing. Only 10% consider buying ethical and sustainable clothing ", _jsx("u", {
        children: "very"
      }), " important."]
    }), "\n", _jsxs(_components.p, {
      children: ["The most important eco-friendly elements when buying clothes are sustainable fabrics and materials (39%), less or no chemicals (36%) and ", _jsx("em", {
        children: "cruelty free"
      }), " (i.e. products or activities that do not harm or kill animals anywhere in the world) (36%)."]
    }), "\n", _jsx(_components.p, {
      children: "The main barriers to buying ethical and eco-friendly clothing are: price (34%), followed by 'it is not clear which eco-friendly aspects are met' (30%) and 'it is difficult to distinguish eco-friendly brands (28%)."
    }), "\n", _jsx(_components.p, {
      children: "27% of European consumers have already reduced their clothing purchases for ethical reasons."
    }), "\n", _jsxs(_components.p, {
      children: ["Europeans give the clothes they no longer wear to charity (69%), or to those around them (34%) or sell them online (21%). 15% leave the items in the closet and 13% say they throw them away in the trash.\n", _jsx("small", {
        children: "Source: YouGov's European Fashion Report 2021, among 11,500 people in ten European markets. (Fieldwork: France, Germany, Austria, Denmark, Finland, Italy, Norway, Spain, Sweden, Switzerland, from September 10 to September 29, 2021)."
      })]
    }), "\n", _jsx("em", {
      children: "Last update: July 2022."
    })]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
